<template>
  <div class="content">
    <div class="line_bac"></div>
    <div class="header">
      <!-- <i class="el-icon-date"></i> -->
      <span
        class="title"
        :class="isShowRecord == 2 ? 'title1' : ''"
        @click="handleTypeBtn(2)"
        v-if="show"
        >徽章发送记录</span
      >
      <span
        class="title"
        :class="isShowRecord == 1 ? 'title1' : ''"
        @click="handleTypeBtn(1)"
        >徽章类别维护</span
      >

      <span
        class="title"
        :class="isShowRecord == 4 ? 'title1' : ''"
        @click="handleTypeBtn(4)"
        >周年徽章推送</span
      >


      <span
        class="title"
        :class="isShowRecord == 3 ? 'title1' : ''"
        @click="handleTypeBtn(3)"
        >徽章发送统计</span
      >
    </div>
    <Maintain v-if="isShowRecord == 1"></Maintain>
    <SendRecord v-if="isShowRecord == 2"></SendRecord>
    <SendStatistics v-if="isShowRecord == 3"></SendStatistics>
    <BadgePush v-if="isShowRecord == 4"></BadgePush>
  </div>
</template>

<script>
import api from "@/apis/medal";
import Maintain from "./maintain.vue";
import SendRecord from "./sendRecord.vue";
import SendStatistics from "./sendStatistics.vue";
import BadgePush from "./badgePush.vue";
export default {
  name: "badgeMaintain",
  components: {
    Maintain,
    SendRecord,
    SendStatistics,
    BadgePush
  },
  data() {
    return {
      isShowRecord: 2,
      show: false
    };
  },
  mounted() {
    this.queryAuthData();
  },
  beforeDestroy() {},
  methods: {
    //是否显示 发放记录
    handleTypeBtn(value) {
      this.isShowRecord = value;
    },
    // 查询 列表
    queryAuthData() {
      this.tableLoading = true;
      api
        .queryMedalUserPermission({ name: this.$store.state.userInfo.username })
        .then(res => {
          if (res.code == 200) {
            if (res.data.list.length > 0 && res.data.list[0].administrators) {
              this.show = true;
            } else {
              if (res.data.list[0].badgeRecord) {
                this.show = true;
              } else {
                this.show = false;
              }
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #f2fcf9;
  height: 100%;
  .line_bac {
    width: 100%;
    height: 20px;
    // background-color: #00ada7;
  }
  .header1 {
    border-bottom: 4px solid #d0d1d1;
  }
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background-color: #efefef;
    font-size: 29px;
    span:nth-child(1) {
      margin: 0 10px 0 40px;
    }
    ::v-deep {
      .el-icon-date {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
      .el-icon-search {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
    }
    .title {
      color: #00ada7;
      margin-left: 60px;
    }
    .title1 {
      color: #00ada7;

      font-weight: bold;
      font-size: 32px;
    }
  }
  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
</style>
